import { ManagerProgressionTaskState } from '@sorare/core/src/__generated__/globalTypes';

export const isClaimableNow = (step: {
  aasmState: ManagerProgressionTaskState;
  claimableAt: Date | null;
}) =>
  step.aasmState === ManagerProgressionTaskState.COMPLETED &&
  (!step.claimableAt || new Date(step.claimableAt).getTime() <= Date.now());
